export default (filtersState) => {
  let filters = {}

  for (const filter in filtersState) {
    const filterItem = filtersState[filter]
    
    
    if (typeof filterItem !== 'undefined') {
      if (!(Array.isArray(filterItem) && filterItem.length === 0)) {
        if (
          filterItem !== null &&
          Object.prototype.hasOwnProperty.call(filterItem, 'value')
        ) {
          
          if (filterItem?.value.length > 0) {
            filters[filter] = /^(true|false)$/i.test(filterItem.value) // если у нас boolean значения в string формате
              ? JSON.parse(filterItem.value) // парсим их в boolean значение
              : filterItem.value
          }
        } else {
          
          if (typeof filterItem === 'string') {
            if (filterItem.length > 0) {
              filters[filter] = filterItem
            }
          } else if (filterItem !== null) {
            filters[filter] = filterItem
          }
        }
      }
    }
  }

  return filters
}
